export default "__VITE_ASSET__m1mjlNz9__"